import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, TooltipButton, IconInfo } from '@americanexpress/dls-react';
import { parseHtml, convertFullToHalfWidth } from '../../utils/util';

const getVal = require('lodash/get');

/**
 * returns DLS input component
 * @param {*} props
 */
/* eslint complexity: ["error", 30] -- need to increase complexity */
const Input = (props) => {
  const {
    fieldType,
    fieldLabel,
    fieldPlaceholder,
    fieldId,
    fieldValue,
    fieldValidation,
    filledFormData,
    memberInfo,
    selectKey,
    preFilledWith,
    isPreFilled,
    fetchUrl,
    fileSubmit,
    textWidth,
    isVerifyCard,
    setFormSubmissionPayload,
    formSubmissionPayload,
  } = props;
  // let preFilledVal = '';
  let dlsClass = 'form-control';
  const [data, setData] = useState(null);
  const [fieldIdValue, setFieldIdValue] = useState('');
  const [inValidError, setInvalidError] = useState(false);
  const customInvalidMsg = fieldValidation && fieldValidation.customInvalidMsg
    ? fieldValidation.customInvalidMsg : 'Please fill in this field';
  // if background color change is required
  if (fieldValidation.bgColor) {
    dlsClass = `${dlsClass} ${fieldValidation.bgColor}`;
  }

  useEffect(() => {
    setFieldIdValue(fieldId);
  }, [fieldId]);

  useEffect(() => {
    if (fieldId !== fieldIdValue) setData('');
    if (filledFormData && filledFormData[fieldId]) {
      setData(filledFormData[fieldId]);
    }
  }, [fieldId]);

  // TODO: logic update will require when data is needed from API in future
  useEffect(() => {
    if (filledFormData && filledFormData[fieldId]) {
      setData(filledFormData[fieldId]);
    }
    if (isPreFilled && preFilledWith === 'filledFormData' && !fetchUrl) {
      if (filledFormData && fieldValidation && fieldValidation.maskedProps) {
        const valueToMask = getVal(filledFormData, fieldValidation.maskedProps.maskFieldId);
        const mask = 'XXXX-XXXXXX-';
        const last5Digits = mask + valueToMask.slice(10, 15);
        setData(last5Digits);
      } else if (filledFormData) {
        // preFilledVal = filledFormData[selectKey];
        setData(getVal(filledFormData, selectKey));
      }
    } else if (isPreFilled && preFilledWith === 'memberInfo' && !fetchUrl) {
      if (memberInfo) {
        // preFilledVal = memberInfo[selectKey];
        setData(getVal(memberInfo, selectKey));
      }
    } else if (fieldValue !== 'default' && fieldValue !== '') {
      // preFilledVal = fieldValue;
      setData(fieldValue);
    }
  }, [memberInfo, filledFormData, fieldId]);

  const [errorMsg, setErrorMessage] = useState(null);

  const convertFileSizeToMB = (fileSizeBytes) => {
    const fileSizeMB = fileSizeBytes / (1024 ** 2);
    return fileSizeMB;
  };
  /**
   * handle input value
   * @param {*} event
   */
  const handleInput = (event) => {
    // handle input type for files
    if (fieldType === 'file') {
      const fileName = event.target.files[0].name;
      const fileSize = event.target.files[0].size;
      // choose regex based on inputType
      let regex;
      if (fieldValidation && fieldValidation.inputType) {
        switch (fieldValidation.inputType) {
          case 'png':
            regex = /(\.png)$/i;
            break;
          default:
            regex = /(\.pdf)$/i;
        }
      }
      // Validate the file with choosen regex
      if (!regex.exec(fileName)) {
        setErrorMessage(fieldValidation.formatErrorMsg);
        fileSubmit(null);
      } else if (convertFileSizeToMB(fileSize) > fieldValidation.fileSizeLimit) {
        setErrorMessage(fieldValidation.sizeErrorMsg);
        fileSubmit(null);
      } else {
        setErrorMessage(null);
        fileSubmit(event.target.files[0]);
      }
    } else {
      setData(event.target.value);
      if (event.target.value === '') setInvalidError(false);
    }
    if (isVerifyCard) {
      if (fieldId === 'cardNumber') {
        const cardNumber = event.target.value;
        setFormSubmissionPayload({
          ...formSubmissionPayload,
          ...{
            elemId: null, cardNumber, cardNameVerify: 1, cardMatchStatus: 1, caseStatusMatch: 1,
          },
        });
      }
      if (fieldId === 'caseNumber') {
        const caseNumber = event.target.value;
        setFormSubmissionPayload({
          ...formSubmissionPayload,
          ...{
            elemId: null, caseNumber, cardNameVerify: 1, cardMatchStatus: 1, caseStatusMatch: 1,
          },
        });
      }
    }
  };

  const inputFocus = useCallback((inputElement) => {
    if (inputElement) {
      // inputElement.focus();
      // window.scrollTo(0, 0);
    }
  }, []);

  const handleKeyPress = (event) => {
    if (fieldValidation.isNumeric) {
      // eslint-disable-next-line unicorn/better-regex -- need
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    } else if (fieldValidation.isAlphabet) {
      const re = /^[A-Za-z]+$/;
      if (!re.test(event.key)) {
        event.preventDefault();
      }
    } else if (fieldValidation.isAlphaNumeric) {
      const alphaNu = /^[!"#$%&'()*+,./:;<=>?@[\\\]^_{|}]*$/;
      if (alphaNu.test(event.key)) {
        event.preventDefault();
      }
    }
  };

  const handleValidation = (e) => {
    const str = e.target.value;
    /* eslint-disable-next-line no-useless-escape -- required */
    const re = /^[\d/a-z\-]+$/i;
    if (!re.test(str)) {
      setInvalidError(true);
    } else if (str.length < fieldValidation.minSize) {
      setInvalidError(true);
    } else if (str.length < fieldValidation.maxSize) {
      setInvalidError(true);
    } else {
      setInvalidError(false);
    }
  };

  const renderElement = fieldType === 'file' ? (
    <input
      type={fieldType}
      id={fieldId}
      name={fieldId}
      className={dlsClass}
      style={{ padding: '1%', borderColor: '#006fcf', color: '#006fcf' }}
      onChange={handleInput}
    />
  ) : (
    <input
      type={fieldType}
      id={fieldId}
      key={fieldId}
      name={fieldId}
      className={dlsClass}
      value={data && textWidth ? convertFullToHalfWidth(data) : data}
      placeholder={fieldPlaceholder}
      onChange={handleInput}
      disabled={fieldValidation.disabled}
      required={fieldValidation.required}
      ref={inputFocus}
      maxLength={fieldValidation.maxSize}
      minLength={fieldValidation.minSize}
      onKeyPress={handleKeyPress}
      onKeyUp={handleValidation}
      aria-describedby="validFieldAlert"
      title={fieldValidation && fieldValidation.hideTitle ? '' : customInvalidMsg}
      onInvalid={(e) => e.target.setCustomValidity(`${customInvalidMsg}`)}
      onInput={(e) => e.target.setCustomValidity('')}
    />
  );

  return (
    <>
      <label className={fieldLabel.cssProperties.style} htmlFor={fieldId}>
        {fieldLabel.label}
      </label>
      {fieldValidation && fieldValidation.isToolTip
        && (
          <>
            <span>{' '}</span>
            <Tooltip id="ToolTip" triggerElement={<TooltipButton icon={<IconInfo size="sm" title="info" />} />}>{fieldValidation.toolTipInfo}</Tooltip>
          </>
        )}
      {!fieldValidation.required && (
        <span
          className={fieldLabel.cssProperties.style}
        >
          {fieldLabel.optionalLabel ? fieldLabel.optionalLabel : ' (Optional)'}
        </span>
      )}
      {fieldLabel
        && fieldLabel.subLabel
        && (
          <div>
            <label className={fieldLabel.cssProperties.subLabelStyle} htmlFor={fieldId}>
              {fieldLabel.subLabel}
            </label>
          </div>
        )}
      {renderElement}
      {errorMsg && <span id="erroMsg" className="validation_error dls-red">{errorMsg}</span>}
      {fieldValidation.disabled && (
        <input type="hidden" id={fieldId} name={fieldId} value={data} />
      )}
      {inValidError && (
        <div id="validFieldAlert" className="alert-form flex" role="alert">
          <i className="valign-top margin-1-r" data-dls-icon="warning" data-dls-icon-variant="filled" data-dls-icon-size="sm" data-dls-icon-role="decorative" />
          <span>{parseHtml(fieldValidation.error)}</span>
        </div>
      )}
    </>
  );
};

Input.propTypes = {
  fieldType: PropTypes.string,
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldPlaceholder: PropTypes.string,
  fieldId: PropTypes.string,
  fieldValue: PropTypes.string,
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  preFilledWith: PropTypes.string,
  fetchUrl: PropTypes.string,
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  memberInfo: PropTypes.objectOf(PropTypes.shape),
  selectKey: PropTypes.string,
  isPreFilled: PropTypes.string,
  fileSubmit: PropTypes.func,
  textWidth: PropTypes.string,
  isVerifyCard: PropTypes.bool,
  setFormSubmissionPayload: PropTypes.func,
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
};

export default Input;
